import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { requireAdmin } from '@/lib/auth-guards'
import { CheckInAlertsPage } from '@/features/check-in-alerts/check-in-alerts-page'

const deniedAlertsSearchSchema = z.object({
  date: z.string().optional().catch(''),
  startDate: z.string().optional().catch(''),
  endDate: z.string().optional().catch(''),
  reviewStatus: z.enum(['pending', 'reviewed']).optional().catch(undefined),
  attemptMethod: z.enum(['rut', 'qr']).optional().catch(undefined),
  q: z.string().optional().catch(''),
  userId: z.string().optional().catch(''),
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(20),
})

export const Route = createFileRoute('/_authenticated/check-ins/denied-alerts')(
  {
    beforeLoad: requireAdmin,
    validateSearch: deniedAlertsSearchSchema,
    component: CheckInAlertsPage,
  }
)
